import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const container = css`
  display: flex;
  flex-direction: column;
  margin: 10px 20px 0;
`;

export const tableDescription = css`
  margin: 20px 0;
`;

export const tableColumnsWrapper = css`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const severitiesWrapper = css`
  padding: 20px;
  background-color: ${colors.custom.lightestGray50};
  margin-left: 50px;
  border-radius: 5px;
`;

export const severityContainer = css`
  display: flex;
  flex-direction: column;

  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

export const severityTitleContainer = css`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const circle = (color: string) => css`
  background-color: ${color};
  border-radius: 50%;

  margin-right: 5px;

  width: 12px;
  height: 12px;
`;

export const columnsDescriptionWrapper = css`
  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

export const footer = css`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  align-items: baseline;
`;

export const buttonFAQ = css`
  text-decoration: none;
  margin-left: 10px;
`;

export const settingsCta = css`
  display: inline;
  margin-left: 10px;
`;

export const link = css`
  text-decoration-line: none;
`;
